import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Panel from 'wonderbly-components/lib/Panel';
import Button from 'wonderbly-components/lib/Button';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import './CartOrderSummary.scss';

const ShippingPrice = (props) => {
  // in Checkout, we show the estimated shipping price ONLY if shipping_estimated is true(coming from Eagle)

  // in Cart the shipping is estimaed by default - we want the option to show or hide the estimated shipping price by adding
  // or removing the estimatedShipping label in Prismic
  const isShippingEstimated = get(props, 'summary.totals_v2.shipping_estimated', false);

  const showShippingPrice = props.showShippingPrice && !isShippingEstimated;
  const haveEnoughInfo = props.label.estimatedShipping && props.value.estimatedShipping;

  if (showShippingPrice && haveEnoughInfo) {
    return (
      <div className="cart-order-summary-row">
        <p className="cart-order-summary-label">{props.label.estimatedShipping}</p>
        <p className="cart-order-summary-price">{props.value.estimatedShipping.formatted}</p>
      </div>);
  }
  return null;
};

const CartOrderSummary = props => {
  const showDiscounts = props.value.discountCode || props.value.discountAmount;
  return (
    <Panel className="cart-order-summary">
      <div className="cart-order-summary-list">
        {props.value.itemTotal && (
          <div className="cart-order-summary-row">
            <p className="cart-order-summary-label">{props.label.itemTotal}</p>
            <p className="cart-order-summary-price">{props.value.itemTotal.formatted}</p>
          </div>
        )}
        {props.showSalesTax && props.label.salesTaxLabel && !isEmpty(props.value.salesTax) && (
          <div className="cart-order-summary-row">
            <p className="cart-order-summary-label">{props.label.salesTaxLabel}</p>
            <p className="cart-order-summary--sales-tax">{props.value.salesTax.formatted}</p>
          </div>
        )}
        <ShippingPrice {...props} />
        {props.label.seeExactCostsLabel &&
          <div className="text-micro see-exact-costs">{props.label.seeExactCostsLabel}</div>
        }
        {props.label.storeCredit && !isEmpty(props.value.storeCredit) && (
          <div className="cart-order-summary-row cart-order-summary-row__store-credit">
            <p className="cart-order-summary-label">{props.label.storeCredit}</p>
            <p className="cart-order-summary-price">{props.value.storeCredit.formatted}</p>
          </div>
        )}
        {showDiscounts && (
          <Fragment>
            <div className="cart-order-summary-row cart-order-summary-row--discount">
              <p className="cart-order-summary-label">
                {props.label.discountAmount}
              </p>
              {props.value.discountAmount && props.value.discountAmount.amount !== '0.0' &&
                <p className="cart-order-summary-price">
                  {props.value.discountAmount.formatted}
                </p>
              }
            </div>
            {props.value.discountCode &&
              <div className="cart-order-summary-row cart-order-summary-row--discount-code">
                <p className="cart-order-summary-label">
                  {props.value.discountCode}
                </p>
                <Button unstyled onClick={props.onRemoveCode}>
                  {props.removeCta}
                </Button>
              </div>
            }
          </Fragment>
        )}
      </div>
      {props.value.discountedTotal && (
        <div className="cart-order-summary-row cart-order-summary-row--large cart-order-summary-row--total">
          <p className="cart-order-summary-label">{props.label.discountedTotal}</p>
          <p className="cart-order-summary-price color-green">
            {props.value.discountedTotal.formatted}
          </p>
        </div>
      )}
    </Panel>
  );
};

const propTypes = {
  label: PropTypes.shape({
    itemTotal: PropTypes.string.isRequired,
    discountedTotal: PropTypes.string.isRequired,
    discountCode: PropTypes.string,
    discountAmount: PropTypes.string,
    estimatedShipping: PropTypes.string,
    storeCredit: PropTypes.string,
    seeExactCostsLabel: PropTypes.string,
    salesTaxLabel: PropTypes.string,
  }),
  value: PropTypes.shape({
    discountCode: PropTypes.string,
    itemTotal: PropTypes.shape({
      formatted: PropTypes.string.isRequired,
    }),
    discountedTotal: PropTypes.shape({
      formatted: PropTypes.string.isRequired,
    }),
    discountAmount: PropTypes.shape({
      formatted: PropTypes.string,
      amount: PropTypes.string
    }),
    estimatedShipping: PropTypes.shape({
      formatted: PropTypes.string,
    }),
    storeCredit: PropTypes.shape({
      formatted: PropTypes.string,
    }),
    salesTax: PropTypes.shape({
      formatted: PropTypes.string,
    }),
  }),
  onRemoveCode: PropTypes.func.isRequired,
  removeCta: PropTypes.string,
  showSalesTax: PropTypes.bool,
  showShippingPrice: PropTypes.bool,
};

CartOrderSummary.propTypes = propTypes;
ShippingPrice.propTypes = propTypes;

export default CartOrderSummary;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartSummary/CartOrderSummary/CartOrderSummary.js